import { Button, Link } from "@caprikorn/dynamo-ui";
import { getFullName } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import { EditPencil01 } from "@icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./UserInformationsCard.module.css";
import type { UserInformationsCardProps } from "./UserInformationsCard.types";
import { AccessManagerCard } from "../AccessManagerCard/AccessManagerCard";

export const UserInformationsCard: FC<UserInformationsCardProps> = ({
  lastName,
  firstName,
  createdAt,
  updatedAt,
  email,
  onClick,
}) => {
  const { t } = useCustomTranslation(["main", "common"]);

  return (
    <AccessManagerCard
      dataTestId="card-user-informations"
      title={t("userDetails.informations.title")}
    >
      <div className={classes.row}>
        <div className={classes.column}>
          <span className={classes.label}>
            {t("userDetails.informations.labels.lastName")}
          </span>
          <span className={classes.content}>
            {getFullName({ lastName }) ||
              t("userDetails.informations.notDocumented")}
          </span>
        </div>
        <div className={classes.column}>
          <span className={classes.label}>
            {t("userDetails.informations.labels.firstName")}
          </span>
          <span className={classes.content}>
            {getFullName({ firstName }) ||
              t("userDetails.informations.notDocumented")}
          </span>
        </div>
      </div>
      {(createdAt || updatedAt) && (
        <div className={classes.row}>
          {createdAt && (
            <div className={classes.column}>
              <span className={classes.label}>
                {t("userDetails.informations.labels.creationDate")}
              </span>
              <span className={classes.content}>
                {t("date", {
                  ns: "common",
                  date: new Date(createdAt),
                  formatParams: {
                    date: {
                      dateStyle: "short",
                    },
                  },
                })}
              </span>
            </div>
          )}
          {updatedAt && (
            <div className={classes.column}>
              <span className={classes.label}>
                {t("userDetails.informations.labels.updateDate")}
              </span>
              <span className={classes.content}>
                {t("date", {
                  ns: "common",
                  date: new Date(updatedAt),
                  formatParams: {
                    date: {
                      dateStyle: "short",
                    },
                  },
                })}
              </span>
            </div>
          )}
        </div>
      )}
      <div className={classes.footer}>
        <div className={classes.email}>
          <span className={classes.label}>
            {t("form.email.label", { ns: "common" })}
          </span>
          <Link className={classes.content} href={`mailto:${email}`}>
            {email}
          </Link>
        </div>
        <Button
          data-testid="button-edit-user-informations"
          onClick={onClick}
          startIcon={EditPencil01}
          variant="secondary"
        >
          {t("button.edit", { ns: "common" })}
        </Button>
      </div>
    </AccessManagerCard>
  );
};
